import { render, staticRenderFns } from "./qeAsideRight.vue?vue&type=template&id=485d9bea&scoped=true&"
import script from "./qeAsideRight.vue?vue&type=script&lang=js&"
export * from "./qeAsideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d9bea",
  null
  
)

export default component.exports